import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import _map from 'lodash/map';
import ContactItem from './ChatContactItem';
import classes from './ChatContacts.module.scss';

/* Note: ReactInfinite doesn't work well here as long as we treat the two lists as a single,
 * scrollable unit */

class ChatContacts extends Component {
  conversationGenerator = (conversation, index) => {
    const { conversationContactDialString, onSelect, onRemove, markConversationAsRead } = this.props;
    const isSelected = conversationContactDialString === conversation.contact.dialString;
    return (
      <div
        key={conversation.conversationId}
        className={classes.contactItemContainer}
        ref={(elt) => {
          if (!isSelected && conversation.unreadMessageCount && !conversation.contact?.isMeeting) {
            if (!elt) {
              this.props.calculateOffsetHeight(null);
            } else {
              this.props.calculateOffsetHeight(elt.offsetTop);
            }
          }
        }}
      >
        <ContactItem
          markConversationAsRead={markConversationAsRead}
          contact={conversation.contact}
          isSelected={isSelected}
          onRemove={(contact) =>
            onRemove(contact, index, conversationContactDialString === conversation.contact.dialString)
          }
          onSelect={onSelect}
          conversation={conversation}
          conversationContactDialString={conversationContactDialString}
        />
      </div>
    );
  };

  render() {
    const { conversations, emptyMessage, title } = this.props;

    return (
      <div>
        {title ? (
          <div data-testid={'contactLabel'} className={classes.contactLabel}>
            {title}
          </div>
        ) : null}
        {conversations.length ? (
          <div className={classes.contactList}>
            {_map(conversations, (conversation, index) => this.conversationGenerator(conversation, index))}
          </div>
        ) : (
          <div>{emptyMessage}</div>
        )}
      </div>
    );
  }
}

ChatContacts.propTypes = {
  conversationContactDialString: PT.string,
  conversations: PT.array,
  emptyMessage: PT.oneOfType([PT.string, PT.element, PT.node, PT.object]),
  onRemove: PT.func,
  onSelect: PT.func,
  title: PT.oneOfType([PT.string, PT.element, PT.node, PT.object]),
  markConversationAsRead: PT.func,
  chatListHeight: PT.number,
  calculateOffsetHeight: PT.func
};

ChatContacts.defaultProps = {
  conversations: [],
  emptyMessage: null,
  title: null
};

export default ChatContacts;
